var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrescriptionBottle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M352 0H32C14.326 0 0 14.326 0 32V96C0 113.674 14.326 128 32 128V456C32 486.875 57.125 512 88 512H296C326.875 512 352 486.875 352 456V128C369.674 128 384 113.674 384 96V32C384 14.326 369.674 0 352 0ZM48 48H336V80H48V48ZM304 456C304 460.406 300.406 464 296 464H88C83.594 464 80 460.406 80 456V416H136C149.25 416 160 405.25 160 392S149.25 368 136 368H80V320H136C149.25 320 160 309.25 160 296S149.25 272 136 272H80V224H136C149.25 224 160 213.25 160 200S149.25 176 136 176H80V128H304V456Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrescriptionBottle);
export default __webpack_public_path__ + "static/media/prescription-bottle.5ad26452780326dfb17f5c5edbac4bbb.svg";
export { ForwardRef as ReactComponent };